"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var sc = _interopRequireWildcard(require("./Heading.styles"));

var propTypes = {
  /** Optional aria text if it should be more descriptive than what is rendered */
  a11yText: _propTypes["default"].string,

  /** Heading content is required */
  children: _propTypes["default"].node.isRequired,

  /** Optional display level(1-6) affects styles only */
  displayLevel: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),

  /** Horizontal divider style */
  hasDivider: _propTypes["default"].bool,

  /** Underline style */
  hasUnderline: _propTypes["default"].bool,

  /** Optional, visually hide the header */
  isHidden: _propTypes["default"].bool,

  /** Optional, renders the children at a lighter font weight */
  isLight: _propTypes["default"].bool,

  /** Optional, using <div> to avoid styles override by global css. */
  isSemantic: _propTypes["default"].bool,

  /** Heading level(1-6) is required. */
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]).isRequired
};
var defaultProps = {
  a11yText: null,
  displayLevel: null,
  hasDivider: false,
  hasUnderline: false,
  isHidden: false,
  isLight: false,
  isSemantic: true
};

var safeValue = function safeValue(n) {
  return n === undefined || n < 1 || (0, _isNan["default"])(n) ? 6 : Math.min(n, 6);
};

function renderHeadingContent(a11yText, children) {
  return a11yText ? /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": true
  }, children) : children;
}

var Heading = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      children = props.children,
      displayLevel = props.displayLevel,
      hasDivider = props.hasDivider,
      isSemantic = props.isSemantic,
      level = props.level,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "displayLevel", "hasDivider", "isSemantic", "level"]);

  var headingRef = _react["default"].useRef(null);

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        if (headingRef.current) {
          if (!moreProps.tabIndex) headingRef.current.setAttribute("tabindex", "-1");
          headingRef.current.focus();
        }
      }
    };
  });

  var safeLevel = safeValue(level);

  var divider = /*#__PURE__*/_react["default"].createElement(sc.Divider, null);

  var elementProps = {
    "aria-label": a11yText || null,
    "aria-level": isSemantic ? null : safeLevel,
    as: isSemantic ? "h".concat(safeLevel) : "div",
    hasDivider: hasDivider,
    ref: headingRef,
    role: isSemantic ? null : "heading",
    safeDisplayLevel: displayLevel ? safeValue(displayLevel) : null,
    safeLevel: safeLevel
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Heading, (0, _extends2["default"])({
    "data-pka-anchor": "heading"
  }, elementProps, moreProps), renderHeadingContent(a11yText, children), hasDivider && divider);
});

Heading.displayName = "Heading";
Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;
var _default = Heading;
exports["default"] = _default;
//# sourceMappingURL=Heading.js.map